import * as React from "react";
const SvgRepeat = props => <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m19 19h-6v-6m-1.9812-11.942a9 9 0 0 1 7.9188 7.8843 9 9 0 0 1-5.8594 9.5151m-12.078-17.457h6v6m1.9812 11.942a9 9 0 0 1-7.9188-7.8843 9 9 0 0 1 5.8594-9.5151" style={{
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "currentcolor"
  }} /></svg>;
export default SvgRepeat;